<span
  class="ai-indicator-container d-flex align-items-center text-white rounded py-1 px-2"
  [ngbTooltip]="helplText | translate"
  [placement]="'top'"
  tooltipClass="ai-tooltip"
  container="body"
>
  <ng-icon
    name="matAutoAwesome"
    size="0.875rem"
  ></ng-icon>
  <span class="ms-1">AI</span>
</span>
